import {combineReducers} from "redux";
import {displayReducer} from "./displayReducer";
import {authReducer} from "./authReducer";

export const createRootReducer = () => {
    return combineReducers({
        displayReducer,
        authReducer
    });
};